import React from "react";

import { serverUrl } from "../../config";

import GridItem from "../../partials/gridItem";
import { useNavigate } from "react-router-dom";

export default function GalleryItem(props) {
  const navigate = useNavigate();

  if (props.creator) {
    return (
      <>
        <GridItem
          xs={12}
          sm={6}
          lg={3}
          xl={3}
          xxl={2}
          itemClass="galleries-creator"
          item={props.item}
          bundle={props.item?.bundle}
          id={props.item?.id}
          title={props.item?.title}
          // field_body={
          //   props.item?.summary ? props.item?.summary : props.item?.body
          // }
          category_label={props.item.category_labels}
          created={props.item?.created}
          hasImg={true}
          imgSrc={`${serverUrl}${props.item.field_featured_image}`}
          alt={`Poster for Gallery ${props.item.id}`}
          cardActionArea={true}
          creator={props.creator}
          cardActionCallBack={
            props.creator
              ? () => {}
              : () => navigate(`/galleries/${props.item?.id}`)
          }
          contentType={props.contentType}
          shareEnabled
          route={"galleries"}
          field_access_token={props.item.access_token}
          sharePrompt={`This is a public link that enables you to share the gallery with your client, no login required.`}
        ></GridItem>
      </>
    );
  } else {
    return (
      <GridItem
        xs={12}
        sm={6}
        md={6}
        itemClass="gallery"
        bundle={props.item?.bundle}
        nid={props.item?.id}
        title={props.item?.title}
        category_label={props.item?.category_labels}
        field_body={props.item?.summary ?? ""}
        created={props.item?.created}
        hasImg={true}
        imgSrc={`${serverUrl}${props.item.field_featured_image}`}
        cardActionArea={true}
        cardActionCallBack={() => navigate(`/galleries/${props.item?.id}`)}
        contentType={props.contentType}
        shareEnabled
        route={"galleries"}
        field_access_token={props.item.field_access_token}
        sharePrompt={`This is a public link that enables you to share the image gallery with your client, no login required.`}
      />
    );
  }
}
